import { FloatingFocusManager, FloatingList } from "@floating-ui/react";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useDropdownContext } from "@/components/General/Dropdown/context/dropdown.context";

type MenuProps = {
    className?: string;
    children: ReactNode;
};

export const Menu = ({ className, children }: MenuProps) => {
    const {
        isOpen,
        elementsRef,
        labelsRef,
        floatingStyles,
        floatingContext,
        getFloatingProps,
        setFloatingRef
    } = useDropdownContext();

    if (!isOpen) return null;

    return (
        <FloatingFocusManager
            context={floatingContext}
            modal={false}
        >
            <div
                {...getFloatingProps()}
                ref={setFloatingRef}
                style={floatingStyles}
                className={cn(
                    "tw:layer-modal/[0] tw:bg-background tw:rounded-md tw:border tw:border-grey-input tw:min-w-12 tw:overflow-hidden",
                    className
                )}
            >
                <FloatingList
                    elementsRef={elementsRef}
                    labelsRef={labelsRef}
                >
                    {children}
                </FloatingList>
            </div>
        </FloatingFocusManager>
    );
};
